<template>
  <d-modal
    class="patients-form-decisions"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <button
      @click.prevent="onClosePopup"
      :class="['mr-1', 'decisions-close-button', show ? 'decisions-close-button-load' : 'decisions-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja wywiadu</template>
          <template v-else>Dodawanie wywiadu</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer ref="patients-form-interview" tag="form">
        <div
          v-for="(interviewField, interviewFieldIndex) in interviewTemplate"
          :key="'interview-field' + interviewFieldIndex">
          <div
            v-if="interviewField.type === 'input'"
            class="form-group decision-box">
            <label
              :for="interviewField.name"
              class="title-box">
              {{ interviewField.label }}
            </label>
            <validation-provider
              :name="interviewField.name"
              v-slot="{ errors }">
              <d-input
                :type="'text'"
                :state="errors.length ? 'invalid' : null"
                v-model="interviewField.value" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p
              v-if="interviewField.text"
              class="decision-note">
              {{ interviewField.text }}
            </p>
          </div>
          <div
            v-if="interviewField.type === 'date'"
            class="form-group decision-box">
            <label
              :for="interviewField.name"
              class="title-box">
              {{ interviewField.label }}
            </label>
            <validation-provider
              :name="interviewField.name"
              v-slot="{ errors }">
              <date-picker
                v-model="interviewField.value"
                valueType="format"
                class="mr-2"
                style="width: 100%" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p
              v-if="interviewField.text"
              class="decision-note">
              {{ interviewField.text }}
            </p>
          </div>
          <div
            v-if="interviewField.type === 'textarea'"
            class="form-group decision-box">
            <label
              :for="interviewField.name"
              class="title-box">
              {{ interviewField.label }}
            </label>
            <validation-provider
              :name="interviewField.name"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="interviewField.value"
                ></textarea>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p
              v-if="interviewField.text"
              class="decision-note">
              {{ interviewField.text }}
            </p>
          </div>
          <div
            v-if="(interviewField.type === 'select') && (interviewField.multiselect === 0)"
            class="form-group decision-box">
            <validation-provider
              :name="interviewField.name"
              v-slot="{ errors }">
              <label
                :for="interviewField.name"
                class="title-box">
                {{ interviewField.label }}
              </label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="interviewField.possibleValues"
                  v-model="interviewField.value"
                  :reduce="boss => boss.id"
                  label="id">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <p
                v-if="interviewField.text"
                class="decision-note">
                {{ interviewField.text }}
              </p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div
            v-if="(interviewField.type === 'select') && (interviewField.multiselect === 1) && (interviewField.specializations === true)"
            class="form-group decision-box">
            <validation-provider
              :name="interviewField.name"
              v-slot="{ errors }">
              <label class="title-box" :for="interviewField.name">{{ interviewField.label }}</label>
              <multi-select
                :multiple="true"
                :ref="'multi-user-list'"
                placeholder="Wybierz..."
                :options="interviewField.possibleValues"
                @input="getValueFromMultiSelect(interviewField.value)"
                v-model="interviewField.value"
                :track-by="'id'"
                label="name"
                select-label="Wybierz"
                deselectLabel="Usuń wybór"
                selectedLabel="Wybrane"
                :taggable="true" />
              <p
                v-if="interviewField.text"
                class="decision-note">
                {{ interviewField.text }}
              </p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <div class="form-group" style="display: none">
              <pre>{{ usersList }}</pre>
              <pre>{{ data.specialization }}</pre>
              <pre>{{ specialization }}</pre>
            </div>
            <div
              v-if="usersList.length && interviewField.specializations === true"
              :key="userKey"
              class="form-group under-box">
              <label
                :for="interviewField.name"
                class="title-box">
                Specjalizacje zespołu
              </label>
              <div
                v-for="(user, index) in usersList"
                :key="index"
                class="form-group">
                <span>
                  <i class="material-icons text-success mr-2">chevron_right</i>
                  <label for="name" class="mr-4 mt-1">
                    {{ user.name }}
                  </label>
                  <validation-provider
                    rules="required"
                    :name="'specializations'"
                    v-slot="{ errors }">
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        :options="specializationsList"
                        @input="pushIdAndSpecialization(user.id, data.specialization[index], index)"
                        :reduce="boss => boss.id"
                        v-model="data.specialization[index]"
                        label="id">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="(interviewField.type === 'select') && (interviewField.multiselect === 1) && (interviewField.specializations === false)"
            class="form-group decision-box">
            <validation-provider
              :name="interviewField.name"
              v-slot="{ errors }">
              <label
                :for="interviewField.name"
                class="title-box">
                {{ interviewField.label }}
              </label>
              <multi-select
                :multiple="true"
                placeholder="Wybierz..."
                :options="interviewField.possibleValues"
                v-model="interviewField.value"
                :track-by="'id'"
                label="name"
                select-label="Wybierz"
                deselectLabel="Usuń wybór"
                selectedLabel="Wybrane"
                :taggable="true" />
              <p
                v-if="interviewField.text"
                class="decision-note">
                {{ interviewField.text }}
              </p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div
            v-if="interviewField.type === 'checkbox'"
            class="form-group decision-box">
            <d-checkbox
              :value="'1'"
              :unchecked-value="'0'"
              v-model="interviewField.value"
              :class="'mb-3'"
              toggle>
              <span class="title-box">
                {{ interviewField.label }}
              </span>
            </d-checkbox>
            <p
              v-if="interviewField.text"
              class="decision-note">
              {{ interviewField.text }}
            </p>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="isEdit && !currentInterviewLoaded"
        class="pb-3 pt-3 text-center overlay-loading">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FilterSelect from '@/components/others/FilterSelect';
import DatePicker from 'vue2-datepicker';
import multiSelect from 'vue-multiselect'
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'patients-form-interviews-popup',
  components: { FilterSelect, DatePicker, multiSelect },
  props: {
    interviewId: {
      default: 0,
      type: Number
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    },
    show: {
      default: false,
      type: Boolean
    },
    visitId: {
      default: 0,
      type: Number
    }
  },
  computed: {
    isEdit () {
      return !!this.interviewId;
    },
    interviewTemplate () {
      if (!this.isEdit) {
        return this.$store.getters.getPatientsInterviewData;
      }

      if (this.currentInterviewLoaded) {
        return this.currentInterview.data_fields;
      }

      return {};
    },
    specializationsList () {
      if (!this.isEdit) {
        return this.$store.getters.getPatientsSpecializationInterviewData;
      }

      if (this.currentInterviewLoaded) {
        return this.currentInterview.specializations;
      }

      return [];
    }
  },
  data () {
    return {
      currentInterview: {},
      currentInterviewLoaded: false,
      data: {
        id: '',
        data_fields: [],
        name: '',
        patient_id: '',
        specialization: []
      },
      specialization: [],
      userKey: 0,
      usersList: []
    };
  },
  mounted () {
    Vue.nextTick(() => {
      if (this.isEdit) {
        this.getInterviewItem();
        return;
      }
      this.patientsInterviewGet();
    })
  },
  methods: {
    getInterviewItem () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/interviews/item/' + this.interviewId,
        outputKey: 'currentInterview',
        loadedKey: 'currentInterviewLoaded',
        params: {
          pagination: false
        },
        successAction: () => {
          setTimeout(() => {
            this.data.patient_id = this.currentInterview.patient_id;
            this.data.id = this.currentInterview.id;
            this.specialization = this.currentInterview.specialization;
            this.getValueFromMultiSelectEdit()
          }, 200)
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-interview'], this.submitForm);
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        patient_id: this.patientId,
        data_fields: this.interviewTemplate,
        specialization: this.specialization,
        id: this.data.id,
        visit_id: this.visitId
      };
      let endpointUrl = this.isEdit ? '/patients/interviews/update/' + this.interviewId : '/patients/interviews/store';
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano wywiad',
        successText: 'Wybrany wywiad został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje wywiadu nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    },
    patientsInterviewGet () {
      this.$store.dispatch('patientsInterviewGet');
    },
    getValueFromMultiSelect(value) {
      this.usersList = value;
    },
    getValueFromMultiSelectEdit() {
      setTimeout(() => {
        for (let i = 0; i < this.specialization.length; i++) {
          if (this.$refs['multi-user-list'][i]) {
            if (this.$refs['multi-user-list'][i].internalValue.length) {
              const refValue = this.$refs['multi-user-list'][i].internalValue;
              for (let j = 0; j < refValue.length; j++) {
                this.usersList[j] = {
                  id: refValue[j].id,
                  name: refValue[j].name
                };
                this.data.specialization.push(refValue[j].specialization);
              }
            }
          }
        }
        this.userKey += 1;
      }, 500);
    },
    pushIdAndSpecialization(value, special, index) {
      this.specialization[index] = {
        id: value,
        specialization: special
      }
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@/assets/scss/patients-form-decisions.scss';
</style>
